(() => {
 // Keep story videos clean while respecting playback restrictions and manual pauses.
 const storyVideos=[...document.querySelectorAll('.rs-reference [data-rs-story] video[data-rs-autoplay]')];
 const visibleStories=new Set(),pausedStories=new Set(),blockedStories=new Set();
 const storyStates=new Map();
 const setStoryPlaying=(video,playing)=>{
  const state=storyStates.get(video);if(!state)return;
  state.wrapper.classList.toggle('rs-story-playing',playing);
  state.button.setAttribute('aria-label',playing?state.button.dataset.rsPauseAria:state.button.dataset.rsPlayAria);
  if(state.label)state.label.textContent=playing?state.button.dataset.rsPauseLabel:state.button.dataset.rsPlayLabel;
 };
 const pauseStory=video=>{
  const state=storyStates.get(video);if(!state)return;
  state.attempt++;state.pending=false;video.pause();setStoryPlaying(video,false);
 };
 const startStory=(video,fromGesture=false)=>{
  const state=storyStates.get(video);
  if(!state||document.hidden||pausedStories.has(video))return;
  if(!fromGesture&&(!visibleStories.has(video)||blockedStories.has(video)||state.pending||!video.paused))return;
  const attempt=++state.attempt;state.pending=true;
  video.defaultMuted=true;video.muted=true;video.loop=true;video.playsInline=true;
  if(!video.getAttribute('src'))video.src=video.dataset.rsSrc;
  const failed=error=>{
   if(state.attempt!==attempt)return;
   state.pending=false;
   if(!video.paused)return;
   if(error.name!=='AbortError')blockedStories.add(video);
   setStoryPlaying(video,false);
  };
  try{const playback=video.play();if(playback&&typeof playback.catch==='function')playback.catch(failed);}
  catch(error){failed(error);}
 };
 const storyObserver=new IntersectionObserver(entries=>entries.forEach(({target:video,isIntersecting,intersectionRatio})=>{
  if(isIntersecting&&intersectionRatio>=0.1){visibleStories.add(video);startStory(video);}
  else{visibleStories.delete(video);pauseStory(video);}
 }),{threshold:[0,0.1]});
 storyVideos.forEach(video=>{
  const wrapper=video.closest('[data-rs-story]'),button=wrapper.querySelector('.rs-camcorder-story-toggle');
  if(!button)return;
  storyStates.set(video,{wrapper,button,label:button.querySelector('.rs-camcorder-story-label'),attempt:0,pending:false});
  video.removeAttribute('autoplay');video.controls=false;
  video.defaultMuted=true;video.muted=true;video.loop=true;video.playsInline=true;
  setStoryPlaying(video,false);button.disabled=false;
  button.addEventListener('click',()=>{
   if(!video.paused){pausedStories.add(video);pauseStory(video);return;}
   pausedStories.delete(video);blockedStories.delete(video);visibleStories.add(video);
   startStory(video,true);
  });
  video.addEventListener('playing',()=>{
   if(video.paused||document.hidden||!visibleStories.has(video)||pausedStories.has(video)){pauseStory(video);return;}
   const state=storyStates.get(video);state.attempt++;state.pending=false;
   blockedStories.delete(video);setStoryPlaying(video,true);
  });
  video.addEventListener('pause',()=>{if(video.paused)setStoryPlaying(video,false);});
  video.addEventListener('error',()=>{blockedStories.add(video);pauseStory(video);});
  storyObserver.observe(video);
 });
 document.addEventListener('visibilitychange',()=>storyVideos.forEach(video=>{if(document.hidden)pauseStory(video);else startStory(video);}));
 // Repeat one complete offer at the reference's 100 px/s. The track moves exactly
 // one offer width, so its last frame joins its first without a gap or phase drift.
 document.querySelectorAll('.rs-reference .rfm-marquee-container').forEach(container=>{
  const track=container.querySelector('.rfm-marquee:not(.placeholder-marquee)');
  const content=track?.querySelector('.rfm-initial-child-container');
  const unit=content?.querySelector('.rfm-child');
  if(!unit)return;
  container.querySelector('.placeholder-marquee')?.remove();
  let previousWidth=0,previousCount=0,fontsReady=document.fonts.status==='loaded';
  const refresh=()=>{
   if(!fontsReady)return;
   const unitWidth=unit.getBoundingClientRect().width;
   const viewportWidth=container.getBoundingClientRect().width;
   if(!unitWidth||!viewportWidth)return;
   const count=Math.ceil(viewportWidth/unitWidth)+1;
   if(count!==previousCount){
    content.querySelectorAll('[data-rs-ticker-copy]').forEach(copy=>copy.remove());
    for(let i=1;i<count;i++){
     const copy=unit.cloneNode(true);copy.setAttribute('data-rs-ticker-copy','');copy.setAttribute('aria-hidden','true');
     copy.removeAttribute('id');copy.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));content.append(copy);
    }
    previousCount=count;
   }
   if(unitWidth!==previousWidth){
    track.style.setProperty('--rs-ticker-distance',`${unitWidth}px`);
    track.style.setProperty('--rs-ticker-duration',`${unitWidth/100}s`);
    previousWidth=unitWidth;
   }
   container.classList.add('rs-ticker-ready');
  };
  const resize=new ResizeObserver(refresh);resize.observe(container);resize.observe(unit);
  document.fonts.ready.then(()=>{fontsReady=true;refresh();});refresh();
 });
 const gallery=document.querySelector('.rs-reference-gallery');
 const show=(index)=>{if(!gallery)return;const slides=[...gallery.querySelectorAll('[data-rs-slide]')];index=(index+slides.length)%slides.length;slides.forEach((s,i)=>{s.hidden=i!==index;if(i!==index)s.querySelectorAll('video').forEach(v=>v.pause());});gallery.querySelectorAll('[data-rs-thumb]').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));};
 document.addEventListener('click',e=>{
  const thumb=e.target.closest('[data-rs-thumb]');if(thumb){show(Number(thumb.dataset.rsThumb));return;}
  const arrow=e.target.closest('[data-rs-gallery-step]');if(arrow){const active=gallery.querySelector('[data-rs-thumb][aria-pressed=true]');show(Number(active.dataset.rsThumb)+Number(arrow.dataset.rsGalleryStep));return;}
  const header=e.target.closest('[data-rs-accordion]');if(header){const open=header.getAttribute('aria-expanded')!=='true';header.setAttribute('aria-expanded',String(open));document.getElementById(header.getAttribute('aria-controls')).setAttribute('aria-hidden',String(!open));return;}
 });
 document.addEventListener('keydown',e=>{if((e.key==='Enter'||e.key===' ')&&e.target.matches('[data-rs-accordion]')){e.preventDefault();e.target.click();}});
 document.querySelectorAll('[data-rs-carousel]').forEach(car=>{
  const track=car.querySelector('.gem-slider');if(!track)return;
  const cards=[...track.querySelectorAll(':scope > .gem-slider-item')];
  car.querySelectorAll('button').forEach(b=>b.hidden=true);
  const dots=document.createElement('div');dots.className='rs-carousel-dots';dots.setAttribute('aria-label',car.dataset.rsChooseSlide);
  cards.forEach((card,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',car.dataset.rsShowSlide.replace('__RS_INDEX__',String(i+1)));b.setAttribute('aria-pressed',String(i===0));b.addEventListener('click',()=>track.scrollTo({left:card.offsetLeft-cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));dots.append(b);});car.append(dots);
  track.addEventListener('scroll',()=>{let index=0,distance=Infinity;cards.forEach((c,i)=>{let d=Math.abs(c.offsetLeft-cards[0].offsetLeft-track.scrollLeft);if(d<distance){distance=d;index=i;}});[...dots.children].forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));},{passive:true});
 });
})();
